<template>
	<section>
        
        <vue-cal
            style="height: 1000px"
            :events="calendarEvents"
            default-view="month"
            @cell-click="onCellClick"
            :disable-views="['years', 'year', 'day','week']"
        >
            <template v-slot:cell-content="{ cell, events }">
                <div class="day-cell-wrapper">

                    <!-----DAY HEADER WITH NUMBER ------>
                    <div class="day-header-new" v-if="cell.formattedDate">
                        <div class="day-number">{{ cell.formattedDate.slice(8, 10) }}</div>
                        <div class="header-indicators">
                            <div class="growth-indicator" v-if="(growthInfo = getGrowthPerDay(events))">
                                <span class="material-icons" :class="growthInfo.growth > 0 ? 'text-success' : 'text-danger'">
                                    {{ growthInfo.growth > 0 ? 'trending_up' : 'trending_down' }}
                                </span>
                            </div>
                        </div>
                    </div>

                    <!-----RIDES SUMMARY ------>
                    <div class="rides-summary" v-if="events.length">
                        <div class="rides-count">
                            <span class="rides-current">{{ getTotalRidesPerDay(events) }}</span>
                            <span class="rides-separator">/</span>
                            <span class="rides-capacity">{{ getCapacityRidesPerDay(events) }}</span>
                        </div>
                        <div class="occupancy-mini">
                            <div
                                class="occupancy-fill"
                                :style="{ width: progressDataPerDay(events).percent + '%' }"
                                :class="'occupancy-' + progressDataPerDay(events).variant"
                            ></div>
                        </div>
                    </div>

                    <!-----VEHICLE BREAKDOWN ------>
                    <div class="vehicle-breakdown" v-if="events.length">
                        <div
                            v-for="event in events"
                            :key="event.uid"
                            class="vehicle-item"
                            v-b-tooltip.hover.html
                            :title="getTooltip(event)"
                        >
                            <span class="material-icons vehicle-icon-mini">
                                {{ getVehicleIcon(event.vehicleType) }}
                            </span>
                            <span class="vehicle-available"
                                :class="{
                                    'text-danger': event.projected >= event.capacity,
                                    'text-success': event.projected <= event.capacity
                                }">
                                <template v-if="event.projected <= event.capacity">
                                    {{ event.capacity - event.projected }}
                                </template>
                                <template v-else>
                                    -{{ event.projected - event.capacity }}
                                </template>
                            </span>
                        </div>
                    </div>

                    <!-----TOP 3 SCHEDULES - COMPACT ------>
                    <div class="schedules-compact" v-if="getTop3SchedulesForDay(events).length > 0">
                        <div class="schedules-grid">
                            <div class="schedule-compact-item" v-for="schedule in getTop3SchedulesForDay(events)" :key="schedule.hour">
                                <span class="schedule-time">{{ schedule.hour }}</span>
                                <span class="schedule-rides">{{ schedule.ridesCount }}</span>
                                <span
                                    v-if="isDifficultSchedule(events, schedule.hour)"
                                    class="material-icons difficult-schedule-icon"
                                    v-b-tooltip.hover.html
                                    :title="getDifficultScheduleTooltip(events, schedule.hour)"
                                >
                                    warning_amber
                                </span>
                            </div>
                        </div>
                    </div>

                    <!-----ASSIGNMENT PROGRESS BAR ------>
                    <div class="assignment-metrics" v-if="getAssignmentMetrics(events)">
                        <b-progress class="assignment-progress" height="11px" show-value>
                            <b-progress-bar
                                :value="getAssignmentMetrics(events).assignedConfirmed"
                                variant="success"
                                :label="`${getAssignmentMetrics(events).assignedConfirmed}%`"
                                v-b-tooltip.hover.html
                                :title="`Assigned Confirmed: ${getAssignmentMetrics(events).assignedConfirmed}% (${getAssignmentMetrics(events).totalAssignedConfirmed} rides)`"
                            />
                            <b-progress-bar
                                :value="getAssignmentMetrics(events).assignedPending"
                                variant="warning"
                                :label="`${getAssignmentMetrics(events).assignedPending}%`"
                                v-b-tooltip.hover.html
                                :title="`Assigned Pending: ${getAssignmentMetrics(events).assignedPending}% (${getAssignmentMetrics(events).totalAssignedPending} rides)`"
                            />
                            <b-progress-bar
                                :value="getAssignmentMetrics(events).unassigned"
                                variant="secondary"
                                :label="`${getAssignmentMetrics(events).unassigned}%`"
                                v-b-tooltip.hover.html
                                :title="`Unassigned: ${getAssignmentMetrics(events).unassigned}% (${getAssignmentMetrics(events).totalUnassigned} rides)`"
                            />
                        </b-progress>
                    </div>
                </div>
            </template>
        </vue-cal>

        <b-modal ref="allotment-day" size="xl" >
            <div v-if="selectedDate" class="my-4">
                <!-------HEADER MODAL-------->
                <div class="text-center mb-3">
                    <h5 class="mb-0 d-flex align-items-center justify-content-center">
                        <md-icon icon="flight" class="mr-1" />
                        {{ item.name }}
                    </h5>
                    <h4 class="mb-1 font-weight-bold d-flex align-items-center justify-content-center">
                        <md-icon icon="calendar_month" class="mr-2" />
                        {{ formattedSelectedDate }}
                    </h4>
                    <div class="occupancy-bar-container container" v-if="selectedDateEvents.length">
                        <b-progress class="mt-2" max="100" show-value v-if="getCapacityRidesPerDay(selectedDateEvents) > 0" show-progress animated>
                            <b-progress-bar
                            :value="progressDataPerDay(selectedDateEvents).percent"
                            :variant="progressDataPerDay(selectedDateEvents).variant"
                            :label="Math.round(progressDataPerDay(selectedDateEvents).percent) + '%'"
                            />
                        </b-progress>
                    </div>
                </div>
                <!-------HEADER MODAL-------->
                <b-row v-if="true">
                    <b-col
                    v-for="(sumaryPerVehicle,key) in tierSummaryForSelectedDate"
                    :key="key"
                    cols="12"
                    md="4"
                    class="mb-2"
                    >
                        <b-card
                            :header="sumaryPerVehicle.tier"
                            class="shadow-sm rounded-lg p-1 text-center"
                            bg-variant="white"
                            border-variant="light"
                            header-bg-variant="primary"
                            header-text-variant="white"
                            >
                            <!-- Projected vs Capacity -->
                            <div class="mb-2">
                                <div class="text-muted small"> Sold  / Capacity  </div>
                                <div class="h5 text-primary mb-0">
                                {{ sumaryPerVehicle.projected }} / <b>{{ sumaryPerVehicle.capacity }}</b>
                                </div>
                            </div>

                            <!-- Slots -->
                            <div class="mb-2">
                                <div class="text-muted small">Available Slots</div>
                                <div
                                class="h5 font-weight-bold mb-0"
                                :class="sumaryPerVehicle.left > 0 ? 'text-success' : 'text-danger'"
                                >
                                {{ sumaryPerVehicle.left }}
                                </div>
                            </div>

                            <!-- Price / Cost / Profit in a row -->
                            <b-row class="text-center my-3">
                                <b-col>
                                <div class="text-muted small">Price</div>
                                <div class="text-success font-weight-bold">${{ sumaryPerVehicle.AvgPriceSoldPerVehicle }}</div>
                                </b-col>
                                <b-col>
                                <div class="text-muted small">Cost</div>
                                <div class="text-danger font-weight-bold">${{ sumaryPerVehicle.AvgCostPerVehicle }}</div>
                                </b-col>
                                <b-col>
                                <div class="text-muted small">Profit</div>
                                <div class="text-info font-weight-bold">{{ sumaryPerVehicle.ProfitPercentPerVehicle }}%</div>
                                </b-col>
                            </b-row>

                            <!-- Progress bar -->
                            <b-progress
                                :value="(sumaryPerVehicle.projected / sumaryPerVehicle.capacity) * 100"
                                :max="100"
                                height="16px"
                                variant="success"
                                animated
                                striped
                            >
                                <b-progress-bar
                                :value="(sumaryPerVehicle.projected / sumaryPerVehicle.capacity) * 100"
                                :label="`${Math.round((sumaryPerVehicle.projected / sumaryPerVehicle.capacity) * 100)}%`"
                                />
                            </b-progress>
                        </b-card>
                    </b-col>
                </b-row>
            </div>
            <div class="text-center mt-2" v-if="selectedDate">
                <b-button variant="success" @click="triggerSearch++">Load more</b-button>
                <div class="mt-5" v-if="triggerSearch>0">
                    <b-form-row>
                        <b-form-group class="col-lg-3" label="Categoria del servicio Venta" v-if="false">
                            <multiselect
                                v-model="filtersAdd.categoryServiceDistribution"
                                :options="serviceTypesCategoriesOpts"
                                group-label="group"
                                group-values="options"
                                group-select
                                multiple
                                label="text"
                                track-by="value"
                                placeholder="Todos"
                                taggable
                            >
                                <template v-slot:clear >
                                    <div class="multiselect__clear" @click="filtersAdd.categoryServiceDistribution = []"></div>
                                </template>
                            </multiselect>
                           
                        </b-form-group>
                        <b-form-group class="col-md-3" label="Canal de venta" >
                        
                            <multiselect
                                    v-model="filtersAdd.salesChannels"
                                    :options="channelOpts"
                                    multiple
                                    label="text"
                                    placeholder="Todos"
                                    taggable
                                    track-by="value"
                            />
                        </b-form-group>
                    </b-form-row>
                    <b-tabs>
                        <b-tab title="Canal de venta">
                            <ChartSaleChannel :filters="filtersDashboard" :triggerSearch="triggerSearch" v-if="triggerSearch > 0" />
                        </b-tab>

                        <b-tab title="Horario">
                            <ChartSchedule :filters="filtersDashboard" :triggerSearch="triggerSearch" v-if="triggerSearch > 0" />
                        </b-tab>

                        <b-tab title="Cutoff">
                            <ChartByCutoff :filters="filtersDashboard" :triggerSearch="triggerSearch" v-if="triggerSearch > 0" />
                        </b-tab>

                        <b-tab title="Tipo de viaje">
                            <ChartByTripType :filters="filtersDashboard" :triggerSearch="triggerSearch" v-if="triggerSearch > 0" />
                        </b-tab>

                        <b-tab title="Distribución proveedores">
                            <ChartBySupplierDistro :filters="filtersDashboard" :triggerSearch="triggerSearch" v-if="triggerSearch > 0" />
                        </b-tab>
                    </b-tabs>
                </div>
            </div>
        </b-modal>
    
	</section>
</template>

<script>

import VueCal from 'vue-cal';
import 'vue-cal/dist/vuecal.css';
import ChartSaleChannel from "@/components/sections/dashboard/charts/operations/RidesPerSalesChannel";
import ChartSchedule from "@/components/sections/dashboard/charts/operations/RidesPerSchedule";
import ChartByCutoff from "@/components/sections/dashboard/charts/comercial/RidesPerCutoffWindow";
import ChartByTripType from "@/components/sections/dashboard/charts/operations/AverageTripType";
import ChartBySupplierDistro from "@/components/sections/dashboard/charts/operations/AveragePerSupplierByAirport";
import Multiselect from 'vue-multiselect';

export default {
    props: ['item'],
	components: {
        VueCal,
        Multiselect,
        ChartSaleChannel,
        ChartSchedule,
        ChartByCutoff,
        ChartByTripType,
        ChartBySupplierDistro
	},
    data() {
        return {
            selectedDate: null,
            triggerSearch: 0,
            filtersAdd:{
                categoryServiceDistribution:null,
                salesChannels:null
            }
        };
    },
    methods: {
        getDayName(formattedDate) {
            const date = new Date(formattedDate);
            const days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
            return days[date.getDay()];
        },
        onCellClick(date) {
            const formattedDate = date.toISOString().slice(0, 10);
            this.selectedDate = formattedDate;
            this.triggerSearch=0
            this.$refs['allotment-day'].show();

        },
        getTotalRidesPerDay(events) {
            return events.reduce((total, e) => {
                return total + (e.projected || 0);
            }, 0);
        },
        getCapacityRidesPerDay(events) {
            return events.reduce((total, e) => {
                return total + (e.capacity || 0);
            }, 0);
        },
        progressDataPerDay(events) {
            const capacity = this.getCapacityRidesPerDay(events);
            const total = this.getTotalRidesPerDay(events);
            if (!capacity) return { percent: 0, variant: 'success' };

            const percent = (total * 100) / capacity;
            let variant = 'success';

            if (percent >= 100) {
             variant = 'danger';
            } else if (percent >= 70) {
             variant = 'warning';
            }

            return { percent, variant };
        },
        getTooltip(event) {
            const status = event.projected >= event.capacity
                ? '<span class="text-danger">🚫 Sobrevendido</span>'
                : '<span class="text-success">✅ Disponible</span>';
            return `${event.vehicleType}<br/>${status}<br/><strong>${event.projected}/${event.capacity}</strong>`;
        },
        getVehicleIcon(type) {
            switch (type) {
            case 'minivan':
                return 'airport_shuttle';
            case 'standardCar':
                return 'directions_car';
            default:
                return 'commute';
            }
        },
        getGrowthPerDay(events) {
            if (events.length === 0) return null;
            let totalPreviousYear = events.reduce((total, e) => {
                const PreviousYearRides = parseFloat(e.PreviousYearRides);
                return total + (isNaN(PreviousYearRides) ? 0 : PreviousYearRides);
            }, 0);

            let totalCurrent = events.reduce((total, e) => {
                const ProjectedRides = parseFloat(e.projected);
                return total + (isNaN(ProjectedRides) ? 0 : ProjectedRides);
            }, 0);
            if (totalPreviousYear === 0) return null;
            const growth = ((totalCurrent - totalPreviousYear) / totalPreviousYear) * 100;
            return {
                ridesPreviousPeriod: totalPreviousYear,
                growth: parseFloat(growth.toFixed(2))
            }
            
        },
        getAssignmentMetrics(events) {
            if (events.length === 0) return null;

            let totalAssignedConfirmed = 0;
            let totalAssignedPending = 0;
            let totalUnassigned = 0;
            let totalProjected = 0;

            events.forEach(event => {
                totalAssignedConfirmed += parseInt(event.AssignedConfirmedRides || 0);
                totalAssignedPending += parseInt(event.AssignedPendingRides || 0);
                totalUnassigned += parseInt(event.UnassignedRides || 0);
                totalProjected += parseInt(event.projected || 0);
            });

            if (totalProjected === 0) return null;

            return {
                assignedConfirmed: ((totalAssignedConfirmed / totalProjected) * 100).toFixed(1),
                assignedPending: ((totalAssignedPending / totalProjected) * 100).toFixed(1),
                unassigned: ((totalUnassigned / totalProjected) * 100).toFixed(1),
                totalAssignedConfirmed,
                totalAssignedPending,
                totalUnassigned,
                totalProjected
            };
        },
        getTop3SchedulesForDay(events) {
            if (events.length === 0) return [];

            // Aggregate all schedules across vehicle types for this day
            const scheduleMap = {};

            events.forEach(event => {
                if (event.TopSchedules && Array.isArray(event.TopSchedules)) {
                    event.TopSchedules.forEach(schedule => {
                        const hour = schedule.hour;
                        if (!scheduleMap[hour]) {
                            scheduleMap[hour] = 0;
                        }
                        scheduleMap[hour] += schedule.ridesCount;
                    });
                }
            });

            // Convert to array and sort by ridesCount descending
            const sortedSchedules = Object.keys(scheduleMap)
                .map(hour => ({
                    hour: hour,
                    ridesCount: scheduleMap[hour]
                }))
                .sort((a, b) => b.ridesCount - a.ridesCount)
                .slice(0, 4); // Get top 4

            return sortedSchedules;
        },
        isDifficultSchedule(events, hour) {
            for (let event of events) {
                if (event.DifficultSchedules && Array.isArray(event.DifficultSchedules)) {
                    const found = event.DifficultSchedules.find(ds => ds.hour === hour);
                    if (found) return true;
                }
            }
            return false;
        },
        getDifficultScheduleTooltip(events, hour) {
            let scheduleData = null;
            for (let event of events) {
                if (event.DifficultSchedules && Array.isArray(event.DifficultSchedules)) {
                    const found = event.DifficultSchedules.find(ds => ds.hour === hour);
                    if (found) {
                        scheduleData = found;
                        break;
                    }
                }
            }

            if (!scheduleData) return '';

            const rejectionRate = scheduleData.rejectionRate || 0;
            const totalRejections = scheduleData.totalRejections || 0;
            const totalConfirmed = scheduleData.totalConfirmed || 0;
            const totalResponses = scheduleData.totalResponses || 0;

            return `<strong>⚠️ Horario Difícil de Asignar</strong><br/>
                    <span style="font-size: 1.2em; color: #ed8936">${rejectionRate}% de rechazo</span><br/>
                    ${totalRejections} rechazos / ${totalConfirmed} confirmados<br/>
                    <span style="font-size: 0.9em; color: #718096">(${totalResponses} asignaciones en 15 días)</span><br/>
                    <em>Proveedores rechazan frecuentemente este horario</em>`;
        }

    },
	computed: {
        eventsCalendar(){
            return this.item.result;
        },
        formattedSelectedDate() {
            if (!this.selectedDate) return '';
            const [year, month, day] = this.selectedDate.split('-').map(Number);
            const localDate = new Date(year, month - 1, day); // mes base 0
            const options = { year: 'numeric', month: 'long', day: 'numeric' };
            return localDate.toLocaleDateString(undefined, options);
        },
        selectedDateEvents() {
            if (!this.selectedDate) return [];
            return this.calendarEvents.filter(event => event.start === this.selectedDate);
        },
        calendarEvents() {
            if (!Array.isArray(this.eventsCalendar)) return [];
            
            const grouped = {};
            this.eventsCalendar.forEach(item => {
                if (!grouped[item.PickupDate]) grouped[item.PickupDate] = [];
                grouped[item.PickupDate].push(item);
            });

            return Object.keys(grouped).flatMap(date => {
                const events = grouped[date];
                return events.map(t => ({
                    uid: `event-${date}-${t.vehicleType}`,
                    title: `${t.vehicleType}`,
                    capacity: t.MaxCapacityPerVehicle,
                    projected: t.ProjectedRides,
                    start: date,
                    end: date,
                    vehicleType: t.vehicleType,
                    status: t.Status,
                    AvgPriceSoldPerVehicle: t.AvgPriceSoldPerVehicle,
                    AvgCostPerVehicle: t.AvgCostPerVehicle,
                    ProfitPercentPerVehicle:t.ProfitPercentPerVehicle,
                    left: t.RidesLeft,
                    PreviousYearRides: t.PreviousYearRides,
                    growth:t.GrowthPercent,
                    AssignedConfirmedRides: t.AssignedConfirmedRides,
                    AssignedPendingRides: t.AssignedPendingRides,
                    UnassignedRides: t.UnassignedRides,
                    TopSchedules: t.TopSchedules || [],
                    DifficultSchedules: t.DifficultSchedules || [],
                    HasDifficultSchedule: t.HasDifficultSchedule || false
                }));
            });
        },
        
        tierSummaryForSelectedDate() {
            if (!this.selectedDate) return [];
            const grouped = {};
            this.selectedDateEvents.forEach(event => {
            if (!grouped[event.vehicleType]) {
                grouped[event.vehicleType] = {
                vehicleType: event.vehicleType,
                status: event.status,
                projected: 0,
                capacity: 0,
                left: 0,
                totalPrice: 0,
                totalCost: 0,
                count: 0,
                ProfitPercentPerVehicle:event.ProfitPercentPerVehicle,
                };
            }

            grouped[event.vehicleType].projected += event.projected || 0;
            grouped[event.vehicleType].capacity += event.capacity || 0;
            grouped[event.vehicleType].left += event.left || 0;
            grouped[event.vehicleType].totalPrice += parseFloat(event.AvgPriceSoldPerVehicle)|| 0;
            grouped[event.vehicleType].totalCost += parseFloat(event.AvgCostPerVehicle) || 0;
            grouped[event.vehicleType].count += 1;
            });
           
            // Map to array with averages
            return Object.values(grouped).map(tier => ({
                tier: `${tier.vehicleType}`,
                ProfitPercentPerVehicle:tier.ProfitPercentPerVehicle,
                status: tier.status,
                projected: tier.projected,
                capacity: tier.capacity,
                left: tier.left,
                AvgPriceSoldPerVehicle: tier.count ? (tier.totalPrice / tier.count).toFixed(2) : '0.00',
                AvgCostPerVehicle: tier.count ? (tier.totalCost / tier.count).toFixed(2) : '0.00',
            }));
        },
        filtersDashboard(){
            let sctDis= null;
            if(!this.$root.isEmpty(this.filtersAdd.categoryServiceDistribution)){
                sctDis       = this.filtersAdd.categoryServiceDistribution.map((item)=>item.value)
            }
           
           
            return {
                groupByCriteria:"per-day",
                dateCriteria: 'service-date',
                startDate: this.selectedDate,
                endDate: this.selectedDate,
                zones:[this.item.zoneId],
                status:["noShow","done","active"],
                revenueType:"gross-revenue",
                iata:this.item.name,
                categoryServiceDistribution: sctDis,
                salesChannels:this.filtersAdd.salesChannels
            }
           
        },
        serviceTypesCategoriesOpts() {
            return [
                {
                    group: "SELECT ALL",
                    options: this.$root.auxVars.serviceTypesCategoriesOpts
                }
            ];
		},
        channelOpts(){
            let aux= [...this.$root.auxVars.salesChannelsOpts];
            return aux;
        },

	},
    mounted(){
        this.$root.auxVars.loadResourcesOpts({
			vm: this,
			resourceNames: ["serviceTypesCategoriesOpts","salesChannelsOpts"]
		});
    },
    beforeDestroy() {
        
    }
};
</script>

<style scoped>
/* Optional: your custom styles here */
</style>
<style>
/* Clean Calendar Cell Design */
.day-cell-wrapper {
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 6px;
  height: 100%;
}

/* Day Header - Minimal */
.day-header-new {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 6px;
  margin-bottom: 2px;
  border-bottom: 3px solid #e2e8f0;
}

.day-number-wrapper {
  display: flex;
  align-items: center;
  gap: 6px;
}

.calendar-icon {
  font-size: 1.2rem;
  color: #667eea;
}

.day-number {
  font-size: 1.5rem;
  font-weight: 800;
  color: #1a202c;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
}

.header-indicators {
  display: flex;
  align-items: center;
  gap: 4px;
}

.growth-indicator .material-icons {
  font-size: 18px;
}

/* Rides Summary - Clean and Simple */
.rides-summary {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.rides-count {
  display: flex;
  align-items: baseline;
  justify-content: center;
  gap: 4px;
  font-weight: 600;
}

.rides-current {
  font-size: 1.1rem;
  color: #2d3748;
}

.rides-separator {
  font-size: 0.9rem;
  color: #a0aec0;
}

.rides-capacity {
  font-size: 0.9rem;
  color: #718096;
}

.occupancy-mini {
  height: 6px;
  background-color: #e2e8f0;
  border-radius: 3px;
  overflow: hidden;
}

.occupancy-fill {
  height: 100%;
  transition: width 0.3s ease;
  border-radius: 3px;
}

.occupancy-success {
  background: linear-gradient(90deg, #48bb78 0%, #38a169 100%);
}

.occupancy-warning {
  background: linear-gradient(90deg, #ed8936 0%, #dd6b20 100%);
}

.occupancy-danger {
  background: linear-gradient(90deg, #f56565 0%, #e53e3e 100%);
}

/* Vehicle Breakdown - Compact */
.vehicle-breakdown {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  padding: 4px;
  background-color: #f7fafc;
  border-radius: 6px;
}

.vehicle-item {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 3px 6px;
  background-color: white;
  border-radius: 4px;
  font-size: 0.75rem;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
}

.vehicle-icon-mini {
  font-size: 16px;
  color: #4a5568;
}

.vehicle-available {
  font-weight: 700;
  font-size: 0.8rem;
}

.text-danger {
  color: #f56565;
}

.text-success {
  color: #48bb78;
}

/* Top 3 Schedules - Ultra Compact */
.schedules-compact {
  display: flex;
  flex-direction: column;
  gap: 4px;
  background-color: #fff5f5;
  padding: 6px;
  border-radius: 6px;
  border: 1px solid #feb2b2;
}

.schedules-header {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  padding-bottom: 2px;
  margin-bottom: 3px;
}

.schedules-fire-icon {
  font-size: 12px;
  color: #f56565;
  animation: fire-flicker 1.5s infinite;
}

.schedules-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 4px;
}

@keyframes fire-flicker {
  0%, 100% {
    transform: scale(1);
    opacity: 1;
  }
  50% {
    transform: scale(1.1);
    opacity: 0.8;
  }
}

.schedules-header-text {
  font-size: 0.7rem;
  font-weight: 700;
  color: #c53030;
  text-transform: uppercase;
  letter-spacing: 0.3px;
}

.schedule-compact-item {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 2px 4px;
  background-color: white;
  border-radius: 3px;
  font-size: 0.65rem;
  transition: all 0.2s;
}

.schedule-compact-item:hover {
  background-color: #fff5f5;
  transform: translateX(2px);
}

.schedule-time {
  font-weight: 600;
  color: #2d3748;
  flex: 1;
}

.schedule-rides {
  font-size: 0.6rem;
  color: #718096;
  background-color: #edf2f7;
  padding: 1px 4px;
  border-radius: 8px;
}

.difficult-schedule-icon {
  font-size: 14px;
  color: #ed8936;
  margin-left: auto;
  animation: pulse-warning 2s infinite;
}

@keyframes pulse-warning {
  0%, 100% {
    opacity: 1;
    transform: scale(1);
  }
  50% {
    opacity: 0.7;
    transform: scale(1.1);
  }
}

/* Assignment Status - Minimal Bar */
.assignment-compact {
  margin-top: auto;
}

.assignment-mini-bar {
  display: flex;
  height: 4px;
  border-radius: 2px;
  overflow: hidden;
  background-color: #e2e8f0;
}

.assignment-segment {
  height: 100%;
  transition: width 0.3s ease;
}

.assignment-segment.confirmed {
  background-color: #48bb78;
}

.assignment-segment.pending {
  background-color: #ed8936;
}

.assignment-segment.unassigned {
  background-color: #cbd5e0;
}

/* Mobile Responsive */
@media (max-width: 768px) {
  .day-cell-wrapper {
    gap: 4px;
    padding: 4px;
  }

  .day-number {
    font-size: 1rem;
  }

  .growth-indicator .material-icons {
    font-size: 14px;
  }

  .rides-current {
    font-size: 0.95rem;
  }

  .rides-capacity {
    font-size: 0.8rem;
  }

  .vehicle-breakdown {
    gap: 6px;
    padding: 3px;
  }

  .vehicle-item {
    padding: 2px 4px;
    gap: 3px;
  }

  .vehicle-icon-mini {
    font-size: 14px;
  }

  .vehicle-available {
    font-size: 0.75rem;
  }

  .schedules-compact {
    padding: 4px;
    gap: 3px;
  }

  .schedules-fire-icon {
    font-size: 12px;
  }

  .schedules-header-text {
    font-size: 0.65rem;
  }

  .schedule-compact-item {
    padding: 2px 4px;
    gap: 4px;
    font-size: 0.7rem;
  }

  .schedule-rides {
    font-size: 0.65rem;
    padding: 1px 4px;
  }
}

</style>